export default {
  globalLayoutName: {
    company: {
      create: 'Stickyweb Company create',
      update: 'Stickyweb Company detail',
      list: "Stickyweb Company list",
    },
    person: {
      create: "Stickyweb Person create",
      update: "Stickyweb Person detail",
      list: "Stickyweb Person list",
    },
    dashboard: {
      list: "Stickyweb Dashboard",
    },
    invoice: {
      list: "Stickyweb Invoice list",
      create: "Stickyweb Invoice create",
      update: "Stickyweb Invoice detail"
    }
  },

  operationSelect: {
    title: "View layouts for"
  },

  layoutList: {
    title: "Layouts",

    noLayoutInList: "You did not yet create any {{type}}",

    private: "Private layouts",
    client: "System layouts",
    global: "Stickyweb fixed layouts",
  },

  input: {
    title: "{{action}} layout",
    name: {
      label: "Layout name",
    },
    private: {
      label: {
        private: "Private layout",
        system: "System layout",
      }
    },

    tabs: {
      firstTab: "Primary",

      addTab: "Add tab",
    },
  },

  toolbar: {
    create: "layout"
  },


  api: {
    systemLayout: {
      name: {
        notNull: "Give the layout a name",
      },
    },
    systemLayoutTab: {
      name: {
        notNull: "Give all tabs a name",
      },
    }
  },
}
